<template>
  <div class="w-full h-full">
    <div class="flex justify-between items-center mb-10px">
      <el-input v-model="keywords" placeholder="请输入关键词" class="mr-10px"></el-input>

      <div class="flex">
        <el-button class="mr-5px" @click="getList">搜索</el-button>
        <el-button @click="openDetail()">新增</el-button>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      height="calc(100% - 140px)"
      class="mb-10px"
      highlight-current-row
      @row-click="clickRow"
    >
      <el-table-column type="index" label="" width="40"></el-table-column>
      <el-table-column
        v-for="col in cloumns"
        show-overflow-tooltip
        :key="col.prop"
        :prop="col.prop"
        :width="col.width"
        :label="col.label"
      >
        <template slot-scope="{ row, column }">
          <span>{{ row[column.property] }}</span>
          <span v-if="column.property === 'Length'" class="ml-3px">M</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="{ row }">
          <div class="flex justify-between">
            <i class="el-icon-edit-outline mr-5px cursor-pointer" @click="openDetail(row)"></i>
            <i class="el-icon-delete cursor-pointer" @click="deleteItem(row)"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="text-center">
      <el-pagination
        class="float-right pr-6px flex"
        background
        size="mini"
        @size-change="getList"
        @current-change="getList"
        :current-page.sync="page.pageNo"
        layout="slot, prev, pager, next"
        :page-size.sync="page.pageSize"
        :total="page.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DiyCodeService from '../../../service/DiyCodeService.js'

export default {
  name: 'Cable',
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      loading: false,

      tableData: [],
      cloumns: [
        {
          prop: 'Name',
          label: '电缆名称',
        },
        {
          prop: 'Length',
          label: '电缆总长',
          width: 90,
        },
        {
          prop: 'Points',
          label: '节点数',
          width: 70,
        },
      ],
      keywords: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      routePtrs: {},
      markers: {},
      positionList: [],
      imgPtr: null,
      allRouteData: [],
      isClose: false,
    }
  },
  computed: {},
  methods: {
    async getList() {
      this.loading = true
      const param = {
        FormEngineKey: 'diy_Cable',
        _PageIndex: this.page.pageNo,
        _PageSize: this.page.pageSize,
        _OrderBy: 'CreateTime',
        _OrderByType: 'desc',
        _Where: [
          {
            Name: 'Name',
            Value: this.keywords,
            Type: 'Like',
          },
        ],
      }
      const [err, res] = await DiyCodeService.getPipesData(param)
      if (!err && res.Code === 1) {
        this.tableData = res.Data
        this.page.total = res.DataCount
      }
      this.loading = false
    },
    async openDetail(val) {
      console.log(Object.values(this.routePtrs), Object.values(this.markers).flat())

      await this.player.Native.Route.setProperty(
        Object.values(this.routePtrs).map((o) => {
          return {
            route: o,
            props: {
              pointVisible: false,
              lineVisible: false,
            },
          }
        })
      )

      await this.player.Native.GisMarker.setProperty(Object.values(this.markers).flat(), {
        visible: false,
      })

      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'BridgeCableDetail',
            origin: 'business',
            name: val ? '编辑电缆' : '新增电缆',
          },
          type: 'business',
          position: 'right',
          props: {
            ...val,
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    clickRow(row) {
      const item = this.positionList.find((o) => {
        return o.cableId === row.Id
      })?.positions
      if (item) {
        const pos = JSON.parse(item).map((o) => {
          return Object.values(o)
        })
        this.player.Native.Camera.moveToPos(pos[0], 0, 200, 1)
      }
    },
    deleteItem(row) {
      this.$confirm('删除后将无法恢复, 确认删除', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      }).then(async () => {
        const [err, res] = await DiyCodeService.getPipesData({
          FormEngineKey: 'diy_CablePositions',
          _Where: [
            {
              Name: 'cableId',
              Value: row.Id,
              Type: '=',
            },
          ],
        })
        if (!err && res.Code === 1) {
          await DiyCodeService.delFormData({
            FormEngineKey: 'diy_Cable',
            Id: row.Id,
          })
          if (res.Data && res.Data.length !== 0) {
            const data = res.Data.map((o) => {
              return {
                FormEngineKey: 'diy_CablePositions',
                Id: o.Id,
              }
            })
            const [er, re] = await DiyCodeService.DelDiyTableRowBatch(data)
            if (!er && re.Code === 1) {
              this.$message.success('删除成功！')
              this.getList()
            }
          } else {
            this.$message.success('删除成功！')
            this.getList()
          }
        }
      })
    },
    async getPosition() {
      const [err, res] = await DiyCodeService.ApiEngine({ ApiEngineKey: 'Get_Route_Position' })
      if (!err && res) {
        this.positionList = res
      }
    },
    async drawRoute(list) {
      console.log(list, '555555555555555')
      for (let i = 0; i < list.length; i++) {
        // eslint-disable-next-line no-await-in-loop
        const ptr = await this.player.Native.Route.create(0)
        this.player.Native.Route.setProperty(ptr, { lineWidth: 10 })
        this.routePtrs[list[i].Id] = ptr

        // eslint-disable-next-line no-loop-func
        const positions = this.positionList.find((o) => {
          return o.cableId === list[i].Id
        })?.positions
        if (positions) {
          const pos = JSON.parse(positions).map((o) => {
            return Object.values(o)
          })
          console.log(pos, JSON.parse(positions))

          // eslint-disable-next-line no-await-in-loop
          await this.player.Native.Route.appendControlPoint(ptr, pos)
          const markerOptions = this.countDistance(pos)
          console.log(markerOptions, 'markerOptions------')
          this.createTextMakers(markerOptions, list[i].Id)
        }
      }
    },
    countDistance(positions) {
      const list = [{ name: '开始', pos: positions[0] }]
      for (let index = 0; index < positions.length - 1; index++) {
        const distance = this.computeDistance(positions[index], positions[index + 1])
        list.push({ name: `${distance}M`, pos: positions[index + 1] })
      }
      return list
    },
    computeDistance(pos1, pos2) {
      if (!pos1 || !pos2) return null
      const dx = pos1[0] - pos2[0]
      const dy = pos1[1] - pos2[1]
      const dz = pos1[2] - pos2[2]
      return Math.sqrt(dx * dx + dy * dy + dz * dz)
    },

    async createTextMakers(list, cableId) {
      const options = list.map((o) => {
        const nameLength = o.name.length
        const textRows = Math.ceil((nameLength * 15) / 160)
        const imgHeight = textRows * 15 + 10
        return {
          localTrans: o.pos, // 定位点，世界坐标，三维向量
          nodeOffset: [0, 0], // 相对定位点的偏移量，二维向量
          imgId: this.imgPtr, // 图片id
          imgSize: [textRows > 1 ? 160 : nameLength * 15, imgHeight || 30], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
          text: o.name || '', // 文本
          textFontSize: 15.0, // 字体大小
          breakWidth: 160, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
          textColor: 0xffffffff, // 文本颜色
          title: null, // 标题
          contentPadding: [5, 5, 5, 5],
        }
      })

      const markers = await this.player.Native.GisMarker.create(options)
      this.markers[cableId] = markers
    },
    async modifyRoute(id) {
      const [err, res] = await DiyCodeService.getPipesData({
        FormEngineKey: 'diy_CablePositions',
        _Where: [
          {
            Name: 'cableId',
            Value: id,
            Type: '=',
          },
        ],
      })
      if (!err && res.Code === 1) {
        const route = this.routePtrs[id]
        if (route) {
          console.log('销毁', route)

          await this.player.Native.Route.destroy(route)
          delete this.routePtrs[id]
          const mark = this.markers[id]
          console.log('销毁mark', mark)

          await this.player.Native.GisMarker.destroy(mark)
          delete this.markers[id]
          const index = this.positionList.findIndex((o) => {
            return o.cableId === id
          })
          if (index >= 0) {
            const list = res.Data.map((o) => {
              return { xAxial: o.xAxial, yAxial: o.yAxial, zAxial: o.zAxial }
            })
            this.positionList[index].positions = JSON.stringify(list)
          }
        } else {
          const list = res.Data.map((o) => {
            return { xAxial: o.xAxial, yAxial: o.yAxial, zAxial: o.zAxial }
          })
          this.positionList.push({
            cableId: id,
            positions: JSON.stringify(list),
          })
        }
        this.drawRoute([{ Id: id }])
      }
    },
    async init(no = 1) {
      if (this.allRouteData.length >= this.page.total || this.isClose) return
      const param = {
        FormEngineKey: 'diy_Cable',
        _PageIndex: no,
        _PageSize: 20,
        _OrderBy: 'CreateTime',
        _OrderByType: 'desc',
      }
      const [err, res] = await DiyCodeService.getPipesData(param)
      if (!err && res.Code === 1) {
        this.drawRoute(res.Data)
        this.allRouteData.push(...res.Data)
        this.init(no + 1)
      }
    },
  },
  watch: {
    transferProps: {
      handler(val) {
        if (val) {
          this.getList()
          setTimeout(() => {
            this.modifyRoute(val.Id)
          }, 500)
        }
        console.warn(val, '======================================')
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    this.imgPtr = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,135')
    await this.getPosition()
    await this.getList()
    this.init()
  },
  beforeDestroy() {
    this.isClose = true

    console.log(this.routePtrs, '===================')

    this.player.Native.Route.destroy(Object.values(this.routePtrs))

    const markerPtr = Object.values(this.markers).flat()
    console.log(markerPtr, 'markerPtr-----------')

    this.player.Native.GisMarker.destroy(markerPtr)
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-radio-button__inner {
  padding: 8px 30px;
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #13b3c9;
  border-color: #13b3c9;
}
.el-button {
  color: #fff !important;
}
</style>
